





















import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import { db } from '@/plugins/firebase';
import { Entry, Project, Collection } from '@/types';

@Component
export default class ProjectView extends Vue {
  project: any = {};
  collections: any = ['ステージ1', 'ステージ2', 'ステージ3'];

  title() {
    return 'プロジェクト詳細';
  }

  jumpToCollection(id:string){
    this.$router.push({name: 'project-collection', params: {projectId: this.project.id, collectionId: id}})
  }

  async bind() {
    const id = this.$route.params.projectId;
    const query = db.collection('projects').doc(id);
    const collectionQuery = db
      .collection('collections')
      .where('projectId', '==', id)
      .orderBy('title', 'asc');
    this.$bind('project', query);
    this.$bind('collections', collectionQuery);
  }
  async created() {
    this.bind();
  }
}
